module.exports = __webpack_public_path__ + "b95b7a545b0fc81827a37a219024900b.svg";